<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import { mdiPlus } from '@mdi/js';
import { AppPermissionsEnum } from '@/api/generator';
import { usePermissionsStore } from '@/stores/permissionsStore';
import { computed } from 'vue';
import PageFeedback from './PageFeedback.vue';
import { PageFeedbackProps } from './types';
import Button from '@/components/buttons/Button.vue';

interface FirstEntityFeedbackProps extends PageFeedbackProps {
  actionText: string;
  permission: AppPermissionsEnum;
  noPermissionMessage: string;
  to?: RouteLocationRaw;
}

const { hasPermissions } = usePermissionsStore();

const props = defineProps<FirstEntityFeedbackProps>();

const emit = defineEmits(['action']);

const hasPermission = computed(() => !props.permission || hasPermissions([props.permission]));

const showAddFirstButton = computed(() => props.actionText && hasPermission.value);
</script>

<template>
  <PageFeedback
    :icon="icon"
    :iconOffset="iconOffset"
    :message="message || (!hasPermission ? noPermissionMessage : undefined)"
  >
    <template #button>
      <Button
        v-if="showAddFirstButton"
        variant="primary"
        class="mt-11"
        :label="actionText"
        :to="to"
        :prependIcon="mdiPlus"
        :maxWidth="500"
        @click="emit('action')"
      />
    </template>
  </PageFeedback>
</template>
